import {
  Fragment,
  useEffect,
  useLayoutEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import TopBarMenuItem, { ITopBarMenuItem } from './TopBarMenuItem';

import { useHorizontalScroll } from 'hooks/useHorizontalScroll';
import {
  ArrowLeftIcon,
  ArrowRightIcon,
  ScreenSize,
  useDraggableContainer,
  useScreenSize,
} from 'plataforma-fundacao-componentes';
import { clsx } from 'helpers/utils/HTMLUtils';
import styles from './styles.module.scss';

interface Props {
  menuItems: ITopBarMenuItem[];
}

export default function TopBarMenus({ menuItems }: Props) {
  const shown = useMemo((): boolean => {
    return menuItems && menuItems.length > 0;
  }, [menuItems]);

  const scrollRef = useHorizontalScroll();

  const [maxScroll, setMaxScroll] = useState<boolean>(false);
  const [initialScroll, setInitialScroll] = useState<boolean>(true);
  const [activeArrows, setActiveArrows] = useState<boolean>(false);

  const { rankedSize } = useScreenSize();

  useDraggableContainer(`#scrollRef`);

  const scroll = (right?: boolean) => {
    if (!right) {
      return (scrollRef.current!.scrollLeft -= 30);
    } else {
      return (scrollRef.current!.scrollLeft += 30);
    }
  };

  const [size, setSize] = useState<any>();
  const valueRef = useRef<any>(size);
  valueRef.current = size;

  const getSize = () => {
    setSize(window!?.innerWidth!);
  };

  useLayoutEffect(() => {
    getSize();
    window.addEventListener('resize', getSize);
    return () => {
      window.removeEventListener('resize', getSize);
    };
  }, []);

  useEffect(() => {
    if (scrollRef!?.current!?.scrollWidth > size) {
      setActiveArrows(true);
    } else {
      setActiveArrows(false);
      setInitialScroll(true);
      setMaxScroll(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [valueRef, size, rankedSize, scrollRef!?.current!?.scrollWidth]);

  return (
    <Fragment>
      <div
        className={clsx([
          styles.relativeWrapper,
          shown ? styles.shownRelativeWrapper : '',
        ])}
      ></div>
      <div className={styles.rootMenus}>
        <div
          id={'scrollRef'}
          className={styles.inside}
          ref={scrollRef!}
          data-draggable={
            rankedSize < ScreenSize.md || activeArrows ? 'true' : false
          }
          onScroll={(e: any) => {
            let max = e.target.scrollWidth - e.target.clientWidth;

            if (e.target.scrollLeft > 0) {
              setInitialScroll(false);
            } else {
              setInitialScroll(true);
            }
            if (max === e.target.scrollLeft) {
              setMaxScroll(true);
            } else {
              setMaxScroll(false);
            }
          }}
        >
          <div
            className={clsx([
              styles.fixedWrapper,
              shown ? styles.shownFixedWrapper : '',
            ])}
          >
            {menuItems!?.map((it: ITopBarMenuItem, key: number) => (
              <TopBarMenuItem {...it} key={key} />
            ))}
          </div>
        </div>
        {activeArrows ? (
          <Fragment>
            <div
              className={clsx([
                styles.prevContainer,
                initialScroll ? styles.initial : '',
                shown ? styles.active : '',
              ])}
              onClick={() => scroll()}
            >
              <div>
                <ArrowLeftIcon />
              </div>
            </div>
            <div
              className={clsx([
                styles.nextContainer,
                maxScroll ? styles.max : '',
                shown ? styles.active : '',
              ])}
              onClick={() => scroll(true)}
            >
              <div>
                <ArrowRightIcon />
              </div>
            </div>
          </Fragment>
        ) : undefined}
      </div>
    </Fragment>
  );
}
